// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3qSH8","primary":"ph5Dc","flasher":"XOtmv","fill":"_1mNLK","secondary":"_7EPch","tertiary":"_1PWq5"};